export const metaInitialData = {
  offset: 0,
  limit: undefined,
  total: undefined,
  http_code: undefined
}
